export default __webpack_public_path__ + "static/media/map-3.ea7cc163.jpg";